import { useScrollReveal } from "@/hooks/useScrollReveal";
import HeroSection from "./components/HeroSection";
import StickyNavSection from "./components/StickyNavSection";
import ServiceOverviewSection from "./components/ServiceOverviewSection";
import ChallengesSection from "./components/ChallengesSection";
import AboutSection from "./components/AboutSection";
import DevelopmentExamplesSection from "./components/DevelopmentExamplesSection";
import BuildOrUseSection from "./components/BuildOrUseSection";
import DevelopmentFlowSection from "./components/DevelopmentFlowSection";
import SmallStartSection from "./components/SmallStartSection";
import DeliverablesSection from "./components/DeliverablesSection";
import ScopeSection from "./components/ScopeSection";
import MaintenanceSection from "./components/MaintenanceSection";
import PricingSection from "./components/PricingSection";
import WhoItIsForSection from "./components/WhoItIsForSection";
import ServiceGuideSection from "./components/ServiceGuideSection";
import FAQSection from "./components/FAQSection";
import RelatedServicesSection from "./components/RelatedServicesSection";
import CTASection from "./components/CTASection";

export default function BusinessToolPage() {
  useScrollReveal();

  return (
    <>
      <HeroSection />
      <StickyNavSection />
      <ServiceOverviewSection />
      <ChallengesSection />
      <AboutSection />
      <DevelopmentExamplesSection />
      <BuildOrUseSection />
      <DevelopmentFlowSection />
      <SmallStartSection />
      <DeliverablesSection />
      <ScopeSection />
      <MaintenanceSection />
      <PricingSection />
      <WhoItIsForSection />
      <ServiceGuideSection />
      <FAQSection />
      <RelatedServicesSection />
      <CTASection />
    </>
  );
}